import { ImageAsset, ImageEntity } from "@shapeable/types";


export const AUSTRALIA_MAP_THUMBNAIL: ImageAsset = {
  id: 'australia-map-thumbnail',
  image: {
    url: 'https://res.cloudinary.com/shapeable/image/upload/v1775619221/doing-collective/image-asset/australia-thumbnail-image_image__australia-thumb_r1zu3e.png',
  }
};

export const BENTLEY_TOGETHER_LOGOS: ImageAsset = {
  id: 'bentley-together-logos',
  name: 'Bentley Together Logos',
  image: {
    url: 'https://res.cloudinary.com/shapeable/image/upload/v1781239833/doing-collective/image-asset/bentley-supported-logo-removed-background_image__bentley-supported-logos-image_xow91j.png'
  }
};